export const FEEDBACK_TYPES = {
  general: 'general',
  delivery: 'delivery',
  kiosk: 'kiosk',
};
